import React, { useRef, useCallback } from "react";
import { List } from "../../Components/common/List/List";
import { ListProvider } from "../../Components/common/List/Providers/List";
import { useAppContext } from "../../AppProvider";
import { useListProps } from "./utilities/list";
import { useTypes } from "../../utilities/types";
import { useIndexOrderEventsContext } from "./providers/Index";
import { getBadge } from "../../Components/Badges/utilities";
import { OrderEvent } from "../../Models/OrderEvent";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "../../utilities/fontawesomeIcons";
import { UncontrolledTooltip } from "reactstrap";

const AnyListProvider = ListProvider as any;
const AnyList = List as any;

export const OrderEvents: React.FC = () => {
  const listRef = useRef<{ refresh: () => void } | null>(null);
  const listProps = useListProps();
  const { parentId } = useIndexOrderEventsContext();

  const renderHeader = () => {
    const { dictionary } = useAppContext();

    return (
      <div className="list-item px-2 border my-1">
        <div
          className="d-grid grid-column align-items-center"
          style={{
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <label className="label-2">{dictionary.words.status}</label>
          <label className="label-2">{dictionary.dates.event_date}</label>
        </div>
      </div>
    );
  };

  const renderItem = useCallback((item: OrderEvent, index: number) => {
    return <ListItem item={item} index={index} />;
  }, []);

  return (
    <>
      <AnyListProvider
        path={listProps.path}
        parentId={parentId}
        defaultPagination={listProps.defaultPagination}
        sorting={listProps.sorting}
      >
        <AnyList
          ref={listRef}
          title={listProps.title}
          renderHeader={renderHeader}
          renderItem={renderItem}
          pagination={listProps.pagination}
          selectRowsEnabled={listProps.selectRowsEnabled}
          actionBar={listProps.actionBar}
        />
      </AnyListProvider>
    </>
  );
};

export default OrderEvents;

const ListItem: React.FC<{ item: OrderEvent; index: number }> = React.memo(
  ({ item, index }) => {
    const { orderStatus } = useTypes();

    const status = orderStatus.find((s) => s.value === item.status);
    return (
      <div className="list-item px-2 border my-1">
        <div
          className="d-grid grid-column align-items-center"
          style={{
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <div>{getBadge({ bgColor: status?.color, text: status?.label })}</div>
          <div>
            <label className="label-3">
              {item.creationUser && (
                <>
                  <FontAwesomeIcon
                    id={"creationUser_" + index}
                    className="cursor-pointer me-2"
                    icon={faUser}
                  />
                  <UncontrolledTooltip
                    placement="bottom"
                    target={"creationUser_" + index}
                  >
                    {item.creationUser}
                  </UncontrolledTooltip>
                </>
              )}
              {item.eventDate
                ? moment(item.eventDate).format("DD/MM/YYYY HH:mm:ss")
                : "-"}
            </label>
          </div>
        </div>
      </div>
    );
  }
);
